<div class="d-flex justify-content-center">
    <div class="spinner-border text-info" role="status">
        <span class="sr-only">Chargement...</span>
    </div>
</div>
